import React, { lazy } from 'react';

const TermsConditions = lazy(() => import('./TermsConditions'));

export { TermsConditions }